import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import complaints from './ComplaintsData';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ImageModal from './ImageModal';
import PhotoRenderer from './PhotoRenderer';
import '../css/ComplaintsPage.css';

const ComplaintsPage = () => {
  const [expandedComplaints, setExpandedComplaints] = useState([]);
  const [modalImage, setModalImage] = useState(null);

  const toggleExpand = (id) => {
    if (expandedComplaints.includes(id)) {
      setExpandedComplaints(expandedComplaints.filter((expandedId) => expandedId !== id));
    } else {
      setExpandedComplaints([...expandedComplaints, id]);
    }
  };

  const handleImageClick = (src) => {
    setModalImage(src);
  };

  if (!complaints) {
    return <div>Loading complaints...</div>;
  }

  return (
    <div className="complaints-feed">
      {complaints.map((complaint) => {
        const isExpanded = expandedComplaints.includes(complaint.id);
        return (
          <div
            key={complaint.id}
            className={`complaint-item ${isExpanded ? 'expanded' : ''}`}
          >
            <h2>
              <Link to={`/complaints/${complaint.id}`}>{complaint.title}</Link>
            </h2>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                img: ({ src, alt }) => (
                  <img
                    src={src}
                    alt={alt}
                    className="markdown-image"
                    onClick={() => handleImageClick(src)}
                  />
                ),
              }}
            >
              {isExpanded
                ? complaint.description
                : complaint.description.slice(0, 300) + '...'}
            </ReactMarkdown>
            {complaint.photos && (
              <div className="photos-preview">
                {complaint.photos.map((photo, index) => (
                  <PhotoRenderer
                    key={index}
                    photo={photo}
                    onClick={handleImageClick}
                  />
                ))}
              </div>
            )}
            {complaint.files && complaint.files.length > 0 && (
              <div className="attached-files-section">
                <h2 className="attached-files-header">Attached Files</h2>
                <ul className="file-list">
                  {complaint.files.map((file, index) => {
                    const fileName = file.split('/').pop();
                    return (
                      <li key={index}>
                        <a href={file} download>
                          {fileName}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {!isExpanded && (
              <div className="show-more">
                <button
                  className="btn-show-more"
                  onClick={() => toggleExpand(complaint.id)}
                >
                  Show More
                </button>
              </div>
            )}
          </div>
        );
      })}
      {modalImage && <ImageModal src={modalImage} onClose={() => setModalImage(null)} />}
    </div>
  );
};

export default ComplaintsPage;
